<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<div class="title-acknowPage"><a href="#/e9781466821705_toc01#toctitle1" id="title1"><span><strong class="b">Acknowledgements</strong></span></a></div>
<div class="p"><span>To Sue Wilson, photographer, Gilli Allan, writer and travelling companion, (who isn’t bossy and doesn’t snore), Jane and Alan Ford for an idea. To Pam and Julian Swindell for taking us to Hollow Cottage in County Mayo. To Aix-en-Provence and New York for being so wonderful. But mostly to Lyn Cluer-Coleman for creating The Stroud House Gallery and letting me watch.</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466821705_ack01.vue?5b34ddea